import React, { Fragment } from "react";
import { withStyles, Button, Drawer } from "@material-ui/core";
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import { getDataWithQueryString, postData} from "../../../../../api/componentAPIs";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import styles from "../../styles";
import DrawerContainerStyles from "../../drawerContainerStyles";
import NotificationForm from "./NotificationForm";
import DataGrid from '@dataGrid';
import GridConfig from "./gridConfig";
import MESSAGES from "../../../../../appMessages";
import SearchBox from "../../../../common/SearchBox";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';
import { sanitizeInput } from "../../../../../utilities/dataUtils";

class Notifications extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            updateNotification: false,
            notificationData:null,
            searchText: "",
            errorMessage: null,
            updateInProgress: false
        }
        this.gridConfig = new GridConfig();
        this.drawerContainer = React.createRef();
        this._isMounted = false;
        this.gridApi = null;
    }

    componentDidMount(){
        this._isMounted = true;
        this.getNotificationData();
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    getNotificationData = () => {
        getDataWithQueryString('GetAllNotifications').then(response => {
            if(response && response.status === 200){
                if(this._isMounted){
                    this.setState({
                        notificationData: response.data,
                        errorMessage: null
                    });
                }
            } else {
                if(this._isMounted){
                    this.setState({
                        notificationData: [],
                        errorMessage: MESSAGES.NOTIFICATION.FETCH_DATA_FAILURE
                    });
                }
            }
        }, error => {
            if(this._isMounted){
                this.setState({
                    notificationData: [],
                    errorMessage: MESSAGES.NOTIFICATION.FETCH_DATA_FAILURE
                });
            }
        })
    }

    onGridReady = ({api}) => {
        api.runCommand = this.runCommand;
        this.gridApi = api;
    }
    runCommand = (command, props ) => {
        switch (command) {
            case'edit': this.setState({
                            editNotification: props.data,
                            updateNotification: true
                        });
                        break;
            case 'delete': this.deleteNotification(props);
                            break;
            default:
                break;
        }
    }

    deleteNotification = (rowNodeProps) => {
        const requestObj = {
            notificationId: rowNodeProps.data.notificationId
        }
        this.updateDeletionProgress(rowNodeProps, true);
        postData('DeleteNotification', requestObj).then(response => {
            if(response && Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(MESSAGES.NOTIFICATION.DELETION_SUCCESS, {variant: "success"});
                this.getNotificationData();
                this.updateDeletionProgress(rowNodeProps, false);
                return;
            }
            this.handleDeleteNotificationError(rowNodeProps, response.status);
        }, () =>{
            this.handleDeleteNotificationError(rowNodeProps);
        })
    }

    handleDeleteNotificationError = (rowNodeProps, statusCode) => {
        this.updateDeletionProgress(rowNodeProps, false);
        if (statusCode === 403) {
            return;
        }
        this.props.enqueueSnackbar(MESSAGES.NOTIFICATION.DELETION_FAILED, {variant: "error"});
    }

    updateDeletionProgress = (rowNodeProps, isDeletionInProgress) => {
        const value = isDeletionInProgress ? "Deleting..." : null;
        rowNodeProps.setValue(value);
    }

    createNewNotification = () => {
        this.setState({
            updateNotification: true,
            editNotification: null
        })
    }

    updateSearchText = (searchText) => {
        this.setState({searchText})
    }

    addOrUpdateNotification = (notification) => {
        this.setState({
            updateInProgress: true
        });
        const requestObj = {
            notificationId: notification.notificationId,
            message: sanitizeInput(notification.message),
            type: notification.type,
            linkLabel: sanitizeInput(notification.linkLabel),
            linkUrl: notification.linkUrl,
            isClosable: notification.isClosable
        };
        const isNewNotification = !Boolean(notification.notificationId)
        postData('CreateOrUpdateNotification', requestObj).then(response => {
            if(response && Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(isNewNotification  ? MESSAGES.NOTIFICATION.ADD_SUCCESS : MESSAGES.NOTIFICATION.UPDATE_SUCCESS , {variant: "success"});
                if(this._isMounted){
                    this.setState({
                        updateInProgress: false
                    })
                    this.getNotificationData();
                    this.closeUpdate();
                }
                return;
            }
            this.handleAddOrUpdateNotificationError(isNewNotification, response.status);
        }, () =>{
            this.handleAddOrUpdateNotificationError(isNewNotification);
        })

    }

    handleAddOrUpdateNotificationError = (isNewNotification, statusCode) => {
        if(this._isMounted){
            this.setState({
                updateInProgress: false
            })
        }
        if (statusCode === 403) {
            return;
        }
        this.props.enqueueSnackbar(isNewNotification ? MESSAGES.NOTIFICATION.ADD_FAILED : MESSAGES.NOTIFICATION.UPDATE_FAILED, {variant: "error"});
    }

    closeUpdate = () =>{
        this.setState({
            updateNotification: false
        })
    }

    render(){
        const { classes } = this.props;
        return (
            <Fragment >
                <header className={`${classes.moduleHeader} ${classes.transition} ${  this.state.updateNotification ? classes.shiftedContent :"" }`} data-automationid = 'userNotification-title'>User Notifications</header>
                <div className={`${classes.moduleContainer} ${classes.transition} ${  this.state.updateNotification ? classes.shiftedContent :"" }`}>
                    <div className={`${classes.gridContainer} ${classes.terminalGridContainer}`} ref={ this.drawerContainer}>
                        <div className={classes.gridHead}>
                            <span className={classes.gridActionIcons}>
                                <SearchBox
                                onChange={this.updateSearchText}
                                customSearchClass={classes.customSearchClass}
                                />
                                <ClearAllFilterButton gridApi={this.gridApi} />
                            </span>
                        </div>
                        <div>
                            <div className={`${classes.dataGrid} ${classes.notificationGrid}`}>
                            {!this.state.errorMessage ? (
                                <DataGrid
                                    defaultColDef={this.gridConfig.config.defaultColDef}
                                    columnDefs={this.gridConfig.config.columns}
                                    columnTypes={this.gridConfig.config.columnTypes}
                                    config={this.gridConfig.config}
                                    rowSelection={this.gridConfig.config.rowSelection}
                                    rowData={this.state.notificationData}
                                    onGridReady={this.onGridReady}
                                    onCellValueChanged={this.onCellValueChanged}
                                    quickFilterText ={this.state.searchText}
                                    onRowDataUpdated={this.selectedUser}
                                />
                                ): (
                                    <div className={classes.errorMessageContainer}>
                                            <div className={classes.errorMessage}> {this.state.errorMessage} </div>
                                    </div>
                                )}
                            </div>
                            <div className={classes.actionContainer}>
                                <Button color="primary" variant="contained" size="small" classes={{root: classes.actionButton}}  onClick={this.createNewNotification} id="newNotification">
                                    Create new notification
                                </Button>
                            </div>
                        </div>
                    </div>
                    {
                        this.state.updateNotification &&
                        <Drawer
                            ModalProps={this.drawerContainer.current ? {container: this.drawerContainer.current} : {}}
                            variant="persistent"
                            anchor="right"
                            open={ this.state.updateNotification}
                            classes={{
                                paper: `${classes.paperAnchor} customScroll ${!this.state.updateNotification ? classes.paperHidden :""}`,
                                modal: classes.modal
                            }}
                            BackdropProps={{
                                className:  classes.backdrop
                            }}
                        >
                           <NotificationForm
                                data={this.state.editNotification}
                                onAdd={this.addOrUpdateNotification}
                                onClose={this.closeUpdate}
                                updateInProgress={this.state.updateInProgress}
                           />
                        </Drawer>
                  }
                </div>
            </Fragment>
        )
    }
}

export default compose(withStyles((theme) => ({
    ...styles(theme),
    ...DrawerContainerStyles(theme),
})),withUserProfile, withSnackbar)(Notifications)